import { useEffect, useRef } from "react";

function useTokenExpiration(token, onExpire) {
  const hasExpired = useRef(false);
  const intervalRef = useRef(null);
  const lastTokenRef = useRef(null);
  const tokenRef = useRef(token);

  const isTokenExpired = (tokenToCheck) => {
    if (
      !tokenToCheck ||
      (typeof tokenToCheck === "string" && tokenToCheck.trim() === "")
    ) {
      return false;
    }

    try {
      const payload = JSON.parse(atob(tokenToCheck.split(".")[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp < currentTime;
    } catch (error) {
      console.error("Error decoding token:", error);
      return true;
    }
  };

  useEffect(() => {
    tokenRef.current = token;

    if (lastTokenRef.current !== token) {
      hasExpired.current = false;
      lastTokenRef.current = token;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (
      token &&
      typeof token === "string" &&
      token.trim() !== "" &&
      !hasExpired.current
    ) {
      if (isTokenExpired(token)) {
        hasExpired.current = true;
        onExpire();
        return;
      }

      intervalRef.current = setInterval(() => {
        const currentToken = tokenRef.current;

        if (
          !currentToken ||
          typeof currentToken !== "string" ||
          currentToken.trim() === ""
        ) {
          return;
        }

        if (isTokenExpired(currentToken) && !hasExpired.current) {
          hasExpired.current = true;
          onExpire();
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        }
      }, 300000); // 5 minutes
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [token, onExpire]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
}

export default useTokenExpiration;
